// Mock data for 3DLoc - Location de matériel au Havre

export const heroTexts = [
  "Location de matériel professionnel pour tous vos projets",
  "Particuliers & Professionnels, du matériel de qualité",
  "Livraison et installation sur toute la Normandie",
  "Plus de 300 références disponibles à la location"
];

// Modification #3: 6 cases qui défilent avec les produits phares
export const heroTools = [
  "Mini-pelle",
  "Broyeur de végétaux",
  "Barnums & Tentes",
  "Bétonnière",
  "Motoculteur",
  "Structures gonflables"
];

export const categories = [
  {
    id: 1,
    name: "Bricolage & Bâtiment",
    slug: "bricolage-travaux",
    icon: "hammer",
    color: "#22C55E"
  },
  {
    id: 2,
    name: "Motoculture & Jardin",
    slug: "jardinage-motoculture",
    icon: "leaf",
    color: "#16A34A"
  },
  {
    id: 3,
    name: "Nettoyage & Logement",
    slug: "nettoyage-logement",
    icon: "sparkles",
    color: "#15803D"
  },
  {
    id: 4,
    name: "Evénementiel & Loisirs",
    slug: "evenementiel-barnum",
    icon: "party",
    color: "#166534"
  }
];

// Modification #3: 6 cases avec les produits demandés (images Lokki)
// Modification #6: Images corrigées - utilisation d'images fiables
export const carouselItems = [
  {
    id: 1,
    name: "Mini-pelle",
    subcategory: "Location Minipelle",
    category: "bricolage-travaux",
    image: "/media/mini-pelle-terra-cs10-r-001-high-yxfm3h-1deea131.jpg"
  },
  {
    id: 2,
    name: "Broyeur de végétaux",
    subcategory: "Location Broyeur de végétaux",
    category: "jardinage-motoculture",
    image: "/media/1738857512679-productimage-67652562dfe18b126c4da-ebba5c9f.jpg"
  },
  {
    id: 3,
    name: "Barnums & Tentes",
    subcategory: "Location Barnums & Tentes",
    category: "evenementiel-barnum",
    image: "/media/1740517079914-productimage-67652562dfe18b126c4da-2a83f5b1.jpg"
  },
  {
    id: 4,
    name: "Bétonnière",
    subcategory: "Location Bétonnière",
    category: "bricolage-travaux",
    image: "/media/betonniere-340-litres-electrique-professionnel-p-b7ab47e9.jpg"
  },
  {
    id: 5,
    name: "Motoculteur",
    subcategory: "Location Motoculteur & motobineuse",
    category: "jardinage-motoculture",
    image: "/media/motoculteur-goldoni-uno-5-8-high-658ff44e.jpg"
  },
  {
    id: 6,
    name: "Structures gonflables",
    subcategory: "Location structure Gonflable",
    category: "evenementiel-barnum",
    image: "/media/1747950868911-productimage-67652562dfe18b126c4da-b93a82a1.jpg"
  }
];

// Modification #5: Nouvel ordre : 1. Bricolage, 2. Jardinage, 3. Nettoyage, 4. Événementiel
// Modification #7: Texte événementiel modifié
// Modification #8: Ajout de texte pour harmoniser l'alignement (2 lignes partout)
// Modification #4 CORRIGÉ: BRICO->"Trouvez le bon outil", JARDIN->"Découvrir les produits", NETTOYAGE->"Trouvez votre bonheur", EVENEMENT->"Voir le catalogue"
export const services = [
  {
    id: 1,
    title: "Bricolage & Bâtiment",
    description: "Parce que l'achat, l'entretien et le stockage d'outillage lourd ou spécifique peut être contraignant, nous vous proposons une large gamme d'outils pour économiser et gagner en efficacité !",
    longDescription: "Maçonnerie, Terrassement, Soudure, Rénovation de locaux, Découpe, Décapage, Peinture... Réalisez vos travaux en sérénité !",
    image: "https://images.unsplash.com/photo-1645651964715-d200ce0939cc?w=1200&auto=format",
    color: "#22C55E",
    features: ["Bétonnière", "Marteau piqueur", "Échafaudage", "Niveau laser"],
    ctaText: "Trouvez le bon outil"
  },
  {
    id: 2,
    title: "Motoculture & Jardin",
    description: "De la préparation de votre terrain à l'entretien de vos plantations, nous mettons à votre disposition toutes les machines nécessaires au bien-être de vos espaces verts.",
    longDescription: "Pour votre grand plaisir, nous réalisons, sur demande, l'entretien de votre terrain ou la création d'un potager. Donnez vie à votre jardin !",
    image: "https://images.unsplash.com/photo-1748893790747-fc2646924cbe?w=1200&auto=format",
    color: "#16A34A",
    features: ["Motoculteur", "Broyeur", "Taille-haie", "Tronçonneuse"],
    ctaText: "Découvrir les produits"
  },
  {
    id: 3,
    title: "Nettoyage & Logement",
    description: "Un diagnostic thermique à réaliser, un déménagement à organiser, un nettoyage efficace ou encore une recherche de coupure de câble électrique ?",
    longDescription: "Ne cherchez plus, trouvez ici les outils géniaux pour embellir votre logement. Détendez-vous dans votre nid douillet !",
    image: "https://images.unsplash.com/photo-1686178827149-6d55c72d81df?w=1200&auto=format",
    color: "#15803D",
    features: ["Shampouineuse", "Karcher", "Caméra thermique", "Diable"],
    ctaText: "Trouvez votre bonheur"
  },
  {
    id: 4,
    title: "Evénementiel & Loisirs",
    description: "Barnums, Tentes de réception, Mobilier, Vaisselle, Structure Gonflable. Réservez nos chapiteaux, châteaux gonflables et agencez-les avec nos accessoires.",
    longDescription: "Pour profiter pleinement du moment, demandez la livraison et l'installation par nos équipes. Réussissez vos évènements en extérieur !",
    image: "/media/pexels-photo-19024675-11c79942.jpg",
    color: "#166534",
    features: ["Barnums & Tentes de réception", "Mobilier & Vaisselle", "Châteaux gonflables", "Déco & Guirlandes"],
    ctaText: "Voir le catalogue"
  }
];

export const advantages = [
  {
    id: 1,
    icon: "clock",
    title: "GAGNEZ DU TEMPS",
    description: "avec nos horaires flexibles"
  },
  {
    id: 2,
    icon: "piggy-bank",
    title: "GARDEZ DU BUDGET",
    description: "avec nos prix malins"
  },
  {
    id: 3,
    icon: "trophy",
    title: "SOYEZ FIER(E)",
    description: "de vos résultats"
  },
  {
    id: 4,
    icon: "shield",
    title: "RESTEZ SEREIN(E)",
    description: "avec nos conseils"
  }
];

// Modification #25-29: FAQ mise à jour selon les demandes
export const faqItems = [
  {
    id: 1,
    question: "Comment puis-je réserver du matériel ?",
    answer: "2 solutions s'offrent à vous : remplir le formulaire de contact sur notre site OU réserver directement en ligne via notre plateforme de réservation en ligne. Un acompte d'environ 30% est requis pour confirmer votre réservation. Le solde restant est dû le jour de la mise à disposition du matériel."
  },
  {
    id: 2,
    question: "Quand dois-je réserver mon matériel ?",
    answer: "Nous vous recommandons de réserver idéalement 2 semaines à l'avance, et plusieurs mois à l'avance pour les périodes de forte demande (mai, juin, juillet, août, septembre). Plus vous réservez tôt, plus vous êtes sûr d'avoir le matériel souhaité."
  },
  {
    id: 3,
    question: "Proposez-vous des services de livraison ?",
    answer: "Oui, nous proposons la livraison et la reprise du matériel en Haute et Basse-Normandie, sur rendez-vous. Les tarifs varient selon le volume. Le retrait sur place à Cauville-sur-Mer est gratuit. Nos horaires d'ouverture : Lundi-Vendredi de 8h45 à 19h sur rdv, Samedi de 9h à 12h, Dimanche de 18h à 19h."
  },
  {
    id: 4,
    question: "Faut-il déposer une caution ?",
    answer: "Oui, pour toute commande, un montant en garantie est demandé. Ce montant est variable selon la commande et sera clairement indiqué sur votre devis sous l'appellation « Dépôt de garantie ». Cette somme sera restituée après contrôle au retour du matériel."
  },
  {
    id: 5,
    question: "Puis-je modifier ou annuler ma réservation ?",
    answer: "Vous pouvez modifier ou annuler votre réservation. En fonction du délai de prévenance, l'acompte pourra être conservé et non remboursé selon nos conditions générales."
  },
  {
    id: 6,
    question: "Devons-nous nettoyer le matériel avant de le retourner ?",
    answer: "Sauf mention contraire, nous demandons que le matériel soit retourné dans un état propre. Cela inclut le retrait de toutes tâches, dépôt ou éléments ajoutés."
  },
  {
    id: 7,
    question: "Comment s'organise le retrait par mes soins ?",
    answer: "Certains articles peuvent être retirés et retournés par vos soins dans nos locaux à Cauville-sur-Mer. Nous vous contacterons quelques jours avant votre réservation afin de convenir d'un rendez-vous. Pensez à réserver idéalement 2 semaines à l'avance, et plusieurs mois en période de forte demande."
  }
];

export const contactInfo = {
  phone: "06 23 89 32 98",
  email: "contact@3dloc.fr",
  address: "76930 Cauville-sur-Mer",
  addressShort: "À 15min du Havre et d'Étretat",
  hours: {
    weekdays: "Lundi au Vendredi : 8h45 à 19h",
    saturday: "Samedi : 9h à 12h",
    sunday: "Dimanche : 18h à 19h",
    note: "Sur rendez-vous"
  }
};

export const stats = [
  { value: "300+", label: "Références" },
  { value: "7J/7", label: "Disponibilité" },
  { value: "15min", label: "Du Havre" },
  { value: "100%", label: "Satisfaction" }
];
